module.exports = __webpack_public_path__ + "img/l_c9.505055ac.png";